import { createFileRoute } from "@tanstack/react-router";
import { ratesQueryOptions, historyQueryOptions } from "@/components/CountryPage";
import { GoldCountryHubPage } from "@/components/gold-hub/GoldCountryHubPage";
import { countryHeadMeta, hubDateSchemas } from "@/lib/seo";

export const Route = createFileRoute("/india/")({
  head: () => {
    const h = countryHeadMeta("india");
    const hubSchemas = hubDateSchemas("india", {
      currency: "INR",
      topCity: "Delhi",
      unitLabel: "per 10 gram",
    });
    return {
      meta: h.meta,
      links: h.links,
      scripts: [
        ...hubSchemas.map((s) => ({
          type: "application/ld+json",
          children: JSON.stringify(s),
        })),
      ],
    };
  },
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(ratesQueryOptions);
    void context.queryClient.prefetchQuery(historyQueryOptions("india"));
  },
  component: () => <GoldCountryHubPage country="india" />,
});